<template>
    <div :id="`graphs-${attach.id}`">
        <div
            v-if="attach.data.graphType === 'bar' && attach.data.answers"
            :key="`attach-${attach.id}`"
            class="ansBars padded"
        >
            <template v-for="(answer, index) in attach.data.answers">
                <div
                    v-if="answer.title"
                    :key="`button-${slide.id}-${index}`"
                    class="ansBarLabel"
                >
                    <div
                        :style="`width: ${isNaN(parseFloat(answer.target)) ? 0 : parseFloat(answer.target) }%`"
                        class="ansBar"
                    />
                    <span>&nbsp;&nbsp;&nbsp;&nbsp;{{ isNaN(parseFloat(answer.target)) ? 0 : parseFloat(answer.target) }}% {{ answer.title }}</span>

                </div>
                <br
                    :key="`button-${slide.id}-${index}-br`"
                    style="clear: both;"
                >
            </template>
        </div>
        <div
            v-else-if="attach.data.graphType === 'gauge' && attach.data.answers"
            :key="`attach-${attach.id}`"
            style="text-align: center"
        >

            <f7-gauge
                :value="parseFloat(attach.data.answers[0].target) / 100"
                :size="180"
                :border-width="10"
                :value-text="`${parseFloat(attach.data.answers[0].target)}%`"
                :value-font-size="41"
                :label-text="attach.data.answers[0].title"
                type="circle"
                border-color="#FC6F65"
                value-text-color="#ff8162"
            />
        </div>
        <div
            v-else-if="attach.data.graphType === 'semigauge' && attach.data.answers"
            :key="`attach-${attach.id}`"
            style="text-align: center"
            class="padded"
        >
            <f7-row style="padding: 0 16px">
                <f7-col class="text-align-center">
                    <f7-gauge
                        :value="parseFloat(attach.data.answers[0].target) / 100"
                        :border-width="10"
                        :value-text="`${parseFloat(attach.data.answers[0].target)}%`"
                        :value-font-size="41"
                        :label-text="attach.data.answers[0].title"
                        type="semicircle"
                        border-color="#FC6F65"
                        value-text-color="#ff8162"
                    />
                </f7-col>
                <f7-col
                    v-if="attach.data.answers[1] && attach.data.answers[1].title"
                    class="text-align-center"
                >
                    <f7-gauge
                        v-if="attach.data.answers[1]"
                        :value="parseFloat(attach.data.answers[1].target) / 100"
                        :border-width="10"
                        :value-text="`${parseFloat(attach.data.answers[1].target)}%`"
                        :value-font-size="41"
                        :label-text="attach.data.answers[1].title"
                        type="semicircle"
                        border-color="#FC6F65"
                        value-text-color="#ff8162"
                    />
                </f7-col>
            </f7-row>
        </div>
    </div>
</template>

<script>
export default {
    props: ['attach', 'slide'],
    store: ['api', 'user'],
    data () {
        return {};
    },
    watch: {},
    mounted: function () {

    },
    methods: {
    }
};
</script>

<style lang="less" scoped>
</style>
